import React, { useEffect } from 'react';
import { useRefinementList } from 'react-instantsearch';

interface ToggleProps {
  attribute: string;
  labelMap?: Record<string, string>;
  className?: string;
  defaultValue?: string;
  value: string;
  onChange: (value: string) => void;
}

export default function AttributeToggle({
  attribute,
  labelMap = {},
  className = '',
  defaultValue = '',
  value,
  onChange,
}: ToggleProps) {
  const { items, refine } = useRefinementList({
    attribute,
    sortBy: ['name:asc'],
  });

  useEffect(() => {
    if (defaultValue && !value) {
      onChange(defaultValue);
    }
  }, [defaultValue, value, onChange]);

  const handleToggle = (newValue: string) => {
    if (value !== newValue) {
      items.forEach((item) => {
        if (item.isRefined) {
          refine(item.value);
        }
      });

      refine(newValue);
      onChange(newValue);
    }
  };

  return (
    <div className={`flex items-center rounded-full bg-gray-100 p-1 ${className}`}>
      {items.map((item) => (
        <button
          key={item.value}
          onClick={() => handleToggle(item.value)}
          disabled={value === item.value}
          className={`rounded-full px-6 py-2 text-sm font-bold transition-all ${
            value === item.value
              ? 'bg-white text-black shadow-md pointer-events-none'
              : 'text-gray-700 hover:bg-gray-200'
          }`}
          aria-pressed={value === item.value}
        >
          {labelMap[item.value] || item.label || item.value}
        </button>
      ))}
    </div>
  );
}
